"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpDetailedPerformanceTable: {
        assessment: 'Assessment',
        section: 'Section',
        studentName: 'Student Name',
        overall: 'Overall',
        nextAriaLabel: 'Go to Next {{item}}',
        previousAriaLabel: 'Go to Previous {{item}}',
        sortAlphabetically: '{{value}}, sorted in {{order}} order. Change order, All other sorted columns will be reseted.',
        sortingOrder: '{{value}} score, sorted in {{order}} order. Change order, All other sorted columns will be reseted.',
        scoreSortingOrder: '{{value}}, sorted in {{order}} order. Change order, All other sorted columns will be reseted.',
        ariaLabelOverallBadge: 'Overall score {{percentage}}, scored as {{proficiency}}.',
        classAverage: 'Class Average',
        studentShowReport: '{{student}}, show report.',
    },
};
